import PropTypes from 'prop-types';

import Expert from './Expert';

const Experts = ({ experts }) => {
  const expertsList = experts.map((expert) => (
    <Expert key={expert.id} {...expert} />
  ));

  return <div className="grid grid--full">{expertsList}</div>;
};

Experts.propTypes = {
  experts: PropTypes.array.isRequired,
};

export default Experts;
